<template>
  <div class="personal">
    <div class="personal__info">
      <div class="personal__info__row">
        <label for="username">用户名：</label>
        <input id="username" type="text" v-model="username" />
      </div>
      <div class="personal__info__row">
        <label for="password">密码：</label>
        <input id="password" type="password" v-model="password" />
      </div>
      <div class="personal__info__row">
        <button class="personal__info__submit" @click="submit()">提交</button>
      </div>
    </div>
    <!-- <div class="personal__date">{{data.expireDate}} 到期</div> -->
    <div class="personal__foot">
      <div class="personal__foot__machine" v-if="data.clusters !== 0">
        您拥有
        <span class="personal__foot__machine__count">{{data.clusters}}</span> 个集群在运行
      </div>
      <div class="personal__foot__machine" v-else>暂时没有集群在运行</div>
      <!-- <div class="personal__foot__extra-btn">扩容 ></div> -->
    </div>
  </div>
</template>

<script>
import vip_img from "@/assets/images/vip.svg";

export default {
  name: "Personal",
  data() {
    return {
      username: "",
      password: "",
      vip_img
    };
  },
  props: {
    data: {
      type: Object,
      default: function() {
        return {
          clusters: 0
        };
      }
    }
  },
  methods: {
    submit() {
      if (this.username !== "" && this.password !== "") {
        this.$router.push({
          query: {
            apply_data: "userInfo",
            username: this.username,
            password: this.password,
            t: +new Date()
          }
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.personal {
  width: 21.25rem;
  height: 12.5rem;
  background-image: url("@{image-url}/vip.png");
  background-size: 100% 100%;
  padding: 1.88rem 1.25rem 1.31rem 1.25rem;
  box-sizing: border-box;
  border-radius: 0.31rem;

  &__info {
    font-size: 1.13rem;
    color: #5e3300;
    display: flex;
    flex-direction: column;

    &__row {
      & label {
        display: inline-block;
        font-size: 0.86rem;
        width: 4.3rem;
      }
      & input {
        outline: none;
      }
    }

    &__submit {
      cursor: pointer;
      outline: none;
      border: none;
      margin-top: 0.23rem;
      width: 3.6rem;
      padding: 0.13rem 0;
      border-radius: 0.53rem;
      text-align: center;
      font-size: 0.86rem;
      background-color: rgba(240, 240, 240, 1);
      transition: background-color 0.3s linear;

      &:hover {
        background-color: rgba(240, 240, 240, 0.7);
      }
      &:active {
        transform: translateY(1px);
        filter: saturate(150%);
      }
    }
  }

  &__foot {
    display: flex;
    color: #5e3300;
    font-size: 0.88rem;
    margin-top: 3.31rem;
    line-height: 1.31rem;

    &__machine {
      flex: 1;

      &__count {
        font-size: 1.13rem;
        font-weight: bold;
      }
    }

    &_extra-btn {
      line-height: 1.25rem;
      width: 3rem;
      text-align: right;

      &:hover {
        cursor: pointer;
      }
    }
  }
}
</style>